import { useCallback } from 'react';
import { userSelector } from 'redux/selectors';
import { useSelector } from 'react-redux';

export const useSocialAuth = (isInvite) => {
  const currentUser = useSelector(userSelector);

  return useCallback(
    (user) => {
      if (isInvite && currentUser?.id !== user?.id) {
        const message = `This invite is for ${currentUser.email}, but you used ${user.email}.\n\nTo continue, use Google/LinkedIn with ${currentUser.email} or continue with email to set a password.`;
        const error = new Error(message);
        error.status = 401;
        error.data = {
          error: message,
        };
        throw error;
      }
    },
    [currentUser, isInvite],
  );
};
